import React, { useState } from "react";
import Heading from "../../../components/Heading";
import { RefreshTimestamp } from "../CommonComponents";
import ModernViewCard from "../CommonComponents/ModernViewCard";
import ViewModeToggle from "../CommonComponents/ViewModeToggle";

const ReportModernViewWrapper = ({
  title,
  newReportUrl,
  navigateTo,
  lastsynced,
  nextScheduledRefresh,
  headerContent,
  children,
  ...headingProps
}) => {
  const [isNewView, setIsNewView] = useState(false); // Default to Modern View as requested

  return (
    <div className="report-container">
      <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
        <Heading
          title={title}
          navigateTo={navigateTo}
          {...headingProps}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px", paddingTop: "5px" }}>
            {!isNewView && (lastsynced || nextScheduledRefresh) && (
              <RefreshTimestamp
                lastRefreshedAt={lastsynced}
                nextScheduledRefresh={nextScheduledRefresh}
              />
            )}
            <ViewModeToggle isNewView={isNewView} setIsNewView={setIsNewView} />
          </div>
        </Heading>
        {!isNewView && headerContent}
      </div>

      {isNewView ? (
        <div style={{ marginTop: "16px" }}>
          <ModernViewCard newReportUrl={newReportUrl} />
        </div>
      ) : (
        <div className="legacy-view-content">
          {children}
        </div>
      )}
    </div>
  );
};


export default ReportModernViewWrapper;
